module.exports = __webpack_public_path__ + "static/media/02.245c9366.jpg";